<template>
	<div id="dashboard-users-sidebar-view">
		<v-card-text v-if="selectedUser" class="d-flex flex-column align-center">
            <v-avatar size="100" class="mb-5">
                <img :src="getGravatar(selectedUser.user.email)" class="dashboard-avatar" alt="" />
            </v-avatar>
            <span class="font-weight-bold mb-3" style="font-size: 16px">{{ selectedUser.user.name }}</span>
            <span class="mb-8" style="font-size: 14px">{{ selectedUser.role_name }}</span>
            <div class="d-flex align-center mb-10" style="font-size: 12px">
                <span class="material-icons mr-2">email</span>
                <span>{{ selectedUser.user.email }}</span>
            </div>

            <v-list class="aboutUser mb-10" v-if="canUseGroups">
                <div class="titleGroup font-weight-bold ml-3 mb-2 text-uppercase">{{ selectedUser.user.name }}'S GROUPS</div>
                <v-list-item v-for="(group, index) in groups" :key="index">
                    <v-list-item-content>
                        <v-list-item-title style="color: #989898; font-size: 13px">{{ group.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-switch
                            :disabled="permission.groups"
                            :input-value="userInGroup(index)"
                            class="ml-1 text-center"
                            color="var(--primary)"
                            inset
                            dark
                            @click="updateUserGroup(index)"
                        />
                    </v-list-item-action>
                </v-list-item>
            </v-list>

			<template v-if="!permission.deleteOrLogout">
                <v-btn class="color-gray rounded-xl mb-5" width="200px" large outlined @click="logoutUser">
                    LOGOUT USER
                </v-btn>
                <v-btn v-if="canDeleteUsers" :loading="deleteUserLoader" class="btn-danger rounded-xl" width="200px" large outlined @click="deleteUser">
                    DELETE USER
                </v-btn>
			</template>
		</v-card-text>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";
import AvatarMixins from "@/mixins/Avatar";

export default {
	mixins: [CanMixin, AvatarMixins],

	name: "UsersSidebar",
	created() {
        if (this.account.plan_id !== 6) return;
		this.$apiService.get(`accounts/${this.account.id}/groups`).then(response => {
			this.groups = response.data;
		});
	},

	data() {
		return {
			groups: [],
			deleteUserLoader: false,
		};
	},

	computed: {
		...mapGetters("Organizations", ["selectedUser"]),
		...mapState("User", ["account", "currentPlan"]),
		...mapState("Organizations", ["users"]),

		permission() {
			return {
				groups: this.account.role_id > 4 || this.account.role_id >= this.selectedUser.role_id,
				deleteOrLogout: this.account.role_id > 3 || this.account.role_id >= this.selectedUser.role_id,
			};
		},

		includedUsers() {
			if (this.account.plan_id == 2 || this.account.plan_id == 3) {
				return 1;
			}
			if (this.account.plan_id == 4 || this.account.plan_id == 5) {
				return 3;
			}
			return 0;
		},
	},

	methods: {
		userInGroup(index) {
			if (this.selectedUser.groups.find(({ id }) => id === this.groups[index].id)) {
				return true;
			} else return false;
		},

		updateUserGroup(index) {
			if (this.userInGroup(index)) {
				this.removeUserFromGroup(index);
			} else {
				this.addUserToGroup(index);
			}
		},

		addUserToGroup(index) {
			this.$store
				.dispatch("Groups/addUserToGroup", {
					group_id: this.groups[index].id,
					account_id: this.selectedUser.id,
				})
				.then(() => {
					this.$store.dispatch("Organizations/fetchUsers");

					this.$store.dispatch("Groups/fetchGroups");
				});
		},

		removeUserFromGroup(index) {
			this.$store
				.dispatch("Groups/removeUserFromGroup", {
					group_id: this.groups[index].id,
					account_id: this.selectedUser.id,
				})
				.then(() => {
					this.$store.dispatch("Organizations/fetchUsers");

					this.$store.dispatch("Groups/fetchGroups");
				});
		},

		logoutUser() {
			this.$apiService.get(`accounts/${this.account.id}/users/${this.selectedUser.user.id}/logout`);
			this.$snackbar('User logged out successfully.', 'success');
		},

		async deleteUser() {
			this.deleteUserLoader = true;

			await this.$apiService.delete(`accounts/${this.account.id}/delete/${this.selectedUser.id}`);
			await this.$store.dispatch("User/fetchCurrentPlan");

			this.updatedUsers = JSON.parse(JSON.stringify(this.users));

			this.$store.commit(
				"Organizations/SET_USERS",
				this.updatedUsers.filter(user => user.id != this.selectedUser.id)
			);

			this.$store.commit("Organizations/SET_SELECTED_USER", null);

			this.deleteUserLoader = false;
		},
	},
};
</script>